import React from 'react';
import PropTypes from 'prop-types';

import ReactVimeo from 'components/consumer/ReactVimeo';

const SingleHeroVideoVimeo = ({
  videoId = 'https://vimeo.com/manage/videos/560538232',
  autoplay = true,
}) => {
  // If video URL was copied while logged into Vimeo, it may be passed into the
  // component in the format https://vimeo.com/manage/videos/560538232 but the
  // only format supported by the Vimeo player is https://vimeo.com/560538232
  const vimeoVideoId = videoId
    ? videoId.replace('/manage/videos', '')
    : videoId;

  return (
    !!videoId && (
      <div className="SingleHeroVideoCore">
        <div className="px-0 py-[56.25%0] relative">
          <div className="h-full left-0 top-0 w-full">
            <ReactVimeo
              className="SingleHeroVideo__video--vimeo"
              video={vimeoVideoId}
              responsive
              autoplay={autoplay || undefined}
              showTitle={false}
            />
          </div>
        </div>
      </div>
    )
  );
};

SingleHeroVideoVimeo.propTypes = {
  videoId: PropTypes.string,
  autoplay: PropTypes.bool,
};

export default SingleHeroVideoVimeo;
